import React, { useEffect } from "react";
import { usePageMetadata } from "../context/PageMetadataContext";
import HomeExperienceRail from "../components/home/HomeExperienceRail";
import "./HomePage.scss";

const HomePage = () => {
  const { setTitle, setShowTitleInHeader } = usePageMetadata();

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowTitleInHeader(true);
    setTitle("Dashboard");
  }, [setShowTitleInHeader, setTitle]);

  return (
    <main className="homePage">
      <HomeExperienceRail />
    </main>
  );
};

export default HomePage;
